module.exports = __webpack_public_path__ + "static/media/W5390484_27.47543fbf.jpg";